import { Constants } from '@core/app-constants';
import { Injectable, inject } from '@angular/core';
import {
  CatalogEventClient,
  EventSessionClient,
  EventSessionForFilterRequestDto,
  EventSessionForFilterResponseDto,
  GetCatalogEventsByRangeResponse,
  PaginatedResultOfEventSessionForFilterResponseDto,
} from '@core/services/apiclient';
import { Observable, map } from 'rxjs';
import { HttpHandlerService } from '@core/services/http-handler.service';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  private readonly eventSessionClient = inject(EventSessionClient);
  private readonly catalogEventClient = inject(CatalogEventClient);
  private readonly httpHandlerService = inject(HttpHandlerService);

  public autocompleteEventForFilterList(
    filter: EventSessionForFilterRequestDto,
  ): Observable<PaginatedResultOfEventSessionForFilterResponseDto> {
    return this.eventSessionClient
      .autocompleteEventForFilterList(filter, Constants.ApiVersion)
      .pipe(this.httpHandlerService.handleApiResponse<PaginatedResultOfEventSessionForFilterResponseDto>());
  }

  public getEventForFilterListByDate(date: Date): Observable<Array<EventSessionForFilterResponseDto>> {
    return this.eventSessionClient
      .getEventForFilterListByDate(date, Constants.ApiVersion)
      .pipe(this.httpHandlerService.handleApiResponse<Array<EventSessionForFilterResponseDto>>());
  }

  public getEventsByRange(dateFrom: Date, dateTo: Date): Observable<EventSessionForFilterResponseDto[]> {
    return this.catalogEventClient.getEventsByRange(dateFrom, dateTo, Constants.ApiVersion).pipe(
      this.httpHandlerService.handleApiResponse<GetCatalogEventsByRangeResponse>(),
      map((response) => response?.events ?? []),
    );
  }
}
